/*
 * This file is part of glowingblue/password-strength.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
export default class EyeButton extends Component {
  view() {
    const {
      showing
    } = this.attrs;
    return m("span", {
      className: "EyeButton",
      onclick: () => showing(!showing())
    }, m(Icon, {
      name: `fas fa-eye${showing() ? '-slash' : ''}`
    }));
  }
}
flarum.reg.add('glowingblue-password-strength', 'forum/components/EyeButton', EyeButton);